<div class="modal" data-iframe-size>
  <div class="icon">
    <img [src]="warningUrl">
  </div>
  <h4 class="title" translate>
    i18n.dialog.closeDesigner.title
  </h4>

  <mat-dialog-content>
    <div class="content" translate>i18n.dialog.closeDesigner.message</div>
  </mat-dialog-content>

  <dialog-buttons [buttons]="buttons"></dialog-buttons>
</div>
